import type { PositioningState } from '~/helpers/learner/positioning'
import { useMutation } from '@apollo/client/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { GQL_SUBMIT_POSITIONING } from '~/gql/positioning/positioning'
import { GQL_MY_SESSIONS } from '~/gql/sessions/sessions'
import { positioningPhase } from '~/helpers/learner/positioning'
import PositioningCard from './PositioningCard'
import PositioningDialog from './PositioningDialog'

type IProps = {
  session: PositioningState & { id: string, objectives?: string[] | null }
}

/**
 * Le positionnement d'un parcours (#321), branché à l'API : l'invitation, le
 * dialogue, l'envoi. Une fois l'entrée remplie, `mySessions` relu rouvre les modules.
 */
function PositioningPrompt({ session }: IProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [submitPositioning, { loading }] = useMutation(GQL_SUBMIT_POSITIONING, { refetchQueries: [GQL_MY_SESSIONS], awaitRefetchQueries: true })
  const phase = positioningPhase(session)
  if (!phase) return null

  const submit = async (levels: number[], needs: string) => {
    try {
      await submitPositioning({
        variables: { input: { sessionId: session.id, phase, ratings: levels.map((level, index) => ({ index, level })), needs: phase === 'ENTRY' ? needs || null : null } },
      })
      toast.success(t('positioning.sent'))
      setOpen(false)
    } catch {
      toast.error(t('positioning.failed'))
    }
  }

  return (
    <>
      <PositioningCard phase={phase} onOpen={() => setOpen(true)} />
      {open && (
        <PositioningDialog phase={phase} objectives={session.objectives ?? []} busy={loading} onCancel={() => setOpen(false)} onSubmit={(levels, needs) => void submit(levels, needs)} />
      )}
    </>
  )
}

export default PositioningPrompt
